import React, { useEffect, useState } from "react";
import OnboardingScreen from "../OnboardingScreen";
import { OnboardingNextButton } from "../OnboardingButtons";

interface Day1StepProps {
  onContinue: () => void;
}

/** Outlined circle that pops in a filled brand disc with a white tick once logged. */
const DayCircle: React.FC<{ done: boolean; shown: boolean }> = ({ done, shown }) => (
  <span className="relative block h-[30px] w-[30px]" aria-hidden="true">
    <span className={`absolute inset-0 rounded-full border-[1.5px] ${done ? "border-transparent" : "border-peak-border"}`} />
    <span
      className="absolute inset-0 rounded-full bg-peak-brand transition-all duration-300 ease-out"
      style={{ opacity: done && shown ? 1 : 0, transform: `scale(${done && shown ? 1 : 0.4})` }}
    />
    {done && (
      <svg viewBox="0 0 24 24" className="absolute inset-0 m-auto h-3.5 w-3.5 transition-opacity duration-300" style={{ opacity: shown ? 1 : 0 }} fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.5l4.5 4.5L19 7" />
      </svg>
    )}
  </span>
);

const Day1Step: React.FC<Day1StepProps> = ({ onContinue }) => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShown(true), 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <OnboardingScreen showBack={false} footer={<OnboardingNextButton label="Continue" onClick={onContinue} />}>
      <div className="flex flex-1 flex-col justify-center gap-7">
        <div className="flex flex-col">
          <p className="font-caveat text-[30px] leading-tight text-peak-text-secondary">The process has begun</p>
          <h1 className="font-funnel text-[32px] font-bold leading-[1.1] tracking-[-0.6px] text-peak-text">
            It takes 4 days to generate your first readiness score.
          </h1>
        </div>
        <div className="flex flex-col gap-2.5">
          <div className="flex items-center justify-between gap-2">
            {Array.from({ length: 4 }).map((_, day) => (
              <DayCircle key={day} done={day === 0} shown={shown} />
            ))}
          </div>
          <p className="font-funnel text-[12px] font-medium text-peak-text-secondary">1 of 4 days logged</p>
        </div>
      </div>
    </OnboardingScreen>
  );
};

export default Day1Step;
